module.exports = __webpack_public_path__ + "static/media/sdet-u-dark.e0a49a9d.png";